const state = () => ({
    loaddingSpin: false
})
const getters = {}
const mutations = {
    setLoadingSpin(state, loaddingSpin) {
        state.loaddingSpin = loaddingSpin
    },
}
const actions = {
    setLoadingSpin({ commit }, loaddingSpin) {
        commit('setLoadingSpin', loaddingSpin)
    },
}
export default { namespaced: true, state, getters, mutations, actions }